async function loadParsePhoneNumberFromString() {
  return await import("libphonenumber-js").then(
    mod => mod.parsePhoneNumberFromString,
  );
}

export async function asyncIsValidPhoneNumber(countryCode, number) {
  const parsePhoneNumberFromString = await loadParsePhoneNumberFromString();

  const phoneNumber = parsePhoneNumberFromString(`+${countryCode} ${number}`);

  return phoneNumber ? phoneNumber.isValid() : false;
}

export async function asyncFormatPhone(countryCode, number) {
  if (!number) {
    return "";
  }

  if (!countryCode) {
    return number;
  }

  if (await asyncIsValidPhoneNumber(countryCode, number)) {
    const parsePhoneNumberFromString = await loadParsePhoneNumberFromString();

    const phoneNumber = parsePhoneNumberFromString(`+${countryCode} ${number}`);

    return phoneNumber.formatInternational();
  }

  return number;
}
